<template>
  <div class="bg-light">
    <div class="livraison-page container">
      <template v-if="cartsupp && cartsupp.items">
        <div class="bg-light">
          <div class="container section-header-breadcrumb">
            <div class="row">
              <div class="content text-left col-sm-12 col-md-12 col-lg-12">
                <h2 class="title-page">
                  <span class="back-link cursor-pointer" @click="BackToLivraison"
                    ><i class="ti ti-back-left font-20 orange-color pe-2"></i
                  ></span>
                  Mode de livraison
                </h2>
                
                <label class="breadcrumb-text"
                  ><span class="pointer-cursor" @click.prevent="GoToDashboard" >Accueil</span> > <span class="pointer-cursor" @click.prevent="GoToStepCart" >Mon panier</span>  > <span class="cursor-pointer" @click="BackToLivraison"> Livraison > </span>
                  <span v-if="!isClient">Livraison à la clinique</span>
                  <span v-else>Livraison chez mon vétérinaire</span>
                </label>
              </div>
            </div>
          </div>
          <div class="livraison-page container">
            <div class="content d-flex flex-column flex-lg-row gap-4 gap-lg-5 mb-4 cart-page-inner">
              <div class="col-12 col-lg-8 block-adresses">
                <!-- Cacher la barre de progression sur mobile -->
                <div class="row step-cart ps-5 pe-5 d-none d-md-flex">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="d-flex gap-4 align-items-center py-4 step-cart-centent">
                      <div class="step-number" @click.prevent="GoToStepCart">
                        <span class="badge mx-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-100 h-75"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="#ec621a"
                            stroke-width="3"
                          >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" /></svg></span>
                        <span class="step-title">Votre panier</span>
                      </div>
                      <div class="separator"></div>

                      <div class="step-number">
                        <span class="badge badge-blue mx-2">2</span>
                        <span class="step-title">Livraison</span>
                      </div>
                      <div class="separator"></div>

                      <div class="step-number">
                        <span class="badge mx-2">3</span>
                        <span class="step-title">Paiement</span>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row justify-content-center" v-if="!isClient">
                  <div class="col-12 col-lg-11 col-md-11 col-sm-11 d-flex justify-content-center justify-content-lg-start">
                    <img :src="iconlocation" class="shipping-icon" />
                    <label class="title-blue my-auto px-2 text-center text-lg-start">Mon adresse de facturation</label>
                  </div>
                </div>

                <div class="row justify-content-center liste-adresses" v-if="!isClient">
                  <div class="col-12 col-lg-11 col-md-11 col-sm-11 my-2">
                    <form class="radio-group">
                      <div
                        class="radio-option"
                        :class="{
                          selected: true,
                        }"
                       
                      >
                        <div class="location">
                          <div class="line1">
                            <img :src="user" />
                            <div class="radio-adresse">
                              {{ ListAddressesFacturations?.firstName }}
                              {{ ListAddressesFacturations?.lastName }}
                              <br />
                              {{ ListAddressesFacturations?.street }},
                              {{ ListAddressesFacturations?.postcode }}
                              {{ ListAddressesFacturations?.city }}
                            </div>
                          </div>
                          <div class="line2">
                            <div v-if="ListAddressesFacturations?.cellphone" class="info-item">
                              <img :src="phone" />
                              <label>{{ ListAddressesFacturations?.cellphone ?? "-" }}</label>
                            </div>
                            <div v-if="ListAddressesFacturations?.email" class="info-item">
                              <img :src="envelope" />
                              <label>{{ ListAddressesFacturations.email ?? "-" }}</label>
                            </div>
                          </div>
                        </div>

                        <div class="custom-radio">
                          <input type="radio" :value="ListAddressesFacturations?.id" v-model="selectedLiv" />
                          <img :src="checked" />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>


                <template v-if="ListAddressesLivraison.length > 0">
                  <div class="row justify-content-center">
                    <div class="col-12 col-lg-11 col-md-11 col-sm-11 mb-2 d-flex justify-content-center justify-content-lg-start">
                      <img :src="iconlocation" class="shipping-icon" />
                      <label class="title-blue my-auto px-2 text-center text-lg-start" v-if="!isClient">Mon adresse de livraison</label>
                      <label class="title-blue my-auto px-2 text-center text-lg-start" v-else >Mes adresses cliniques</label>
                    </div>
                  </div>
                  <div class="row justify-content-center liste-adresses">
                    <div class="col-12 col-lg-11 col-md-11 col-sm-11 my-2">
                      <form class="radio-group">
                        <div
                          v-for="adress in ListAddressesLivraison"
                          :key="adress.id"
                          class="radio-option"
                          :class="{
                            selected: selectedLiv === adress.id,
                          }"
                          @click="selectedLiv = adress.id"
                        >
                          <!-- Contenu principal -->
                          <div class="location">
                            <div class="line1">
                              <img :src="user" />
                              <div class="radio-adresse">
                                {{ adress.firstName }}
                                {{ adress.lastName }}
                                <br />
                                {{ adress.street }},
                                {{ adress.postcode }}
                                {{ adress.city }}
                              </div>
                            </div>
                            <div class="line2">
                              <div v-if="adress.cellphone" class="info-item">
                                <img :src="phone" />
                                <label>{{ adress.cellphone ?? "-" }}</label>
                              </div>
                              <div v-if="adress.email" class="info-item">
                                <img :src="envelope" />
                                <label>{{ adress.email ?? "-" }}</label>
                              </div>
                            </div>
                          </div>

                          <!-- Radio customisé à droite -->
                          <div class="custom-radio">
                            <input type="radio" :value="adress.id" v-model="selectedLiv" />
                            <img v-if="selectedLiv === adress.id" :src="checked" />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </template>
                <div class="row justify-content-center sub-content">
                  <div class="col-12 col-lg-11 col-md-11 col-sm-11 my-2 text-center text-lg-start">
                    <p v-if="!isClient">
                      Vous souhaitez ajouter ou modifier une adresse de clinique ?
                      <router-link to="/contact" class="title-blue">Contactez-nous</router-link>
                    </p>
                    <p v-if="!isClient">
                      Vous souhaitez livrer au domicile de votre client ?
                      <span class="title-blue cursor-pointer" @click.prevent="GoToLivraisonDomicile"
                        >Veuillez sélectionner la livraison à domicile</span
                      >
                    </p>
                    <p v-else >
                      Vous souhaitez être livré(e) chez vous ?
                      <span class="title-blue cursor-pointer" @click.prevent="GoToLivraisonDomicile"
                        >Veuillez sélectionner la livraison à domicile</span
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4 py-3 block-recap">
                 <label class="title-recap">Récapitulatif de la commande</label>

                 <div v-if="showWarehouseNotice" class="alert alert-info my-3">
                  <i class="ti ti-info-circle"></i>
                  <p>
                    <strong>Information :</strong> Suite à un arrêté préfectoral en lien avec l'épisode de froid en cours, les transporteurs ne sont pas autorisés à circuler dans la région de notre entrepôt logistique avant la fin de journée du 06 janvier, au plus tôt. Cela peut donc entrainer un léger retard dans la prise en charge de vos commandes par ces derniers.
                  </p>
                </div>
                 
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center">
                  <label class="recap-text p-0">Prix des produits</label>
                  <span class="recap-text">{{ TotalCart }} € HT</span>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center"  v-if="showRemiseLine && remise">
                  <p class="col-6 col-lg-6 p-0">
                    <label class="recap-text">Remise</label>
                    <br />
                    <span class="text-slogan" v-if="couponCode"> {{ couponCode }} </span>
                    <span class="text-slogan" v-else>inclus dans le prix des produits</span>
                  </p>
                  <span class="recap-text">{{ remise }} €</span>
                </div>
                
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if='tvaTieCode==="0"'>
                  <label class="recap-text p-0">TVA</label>
                  <span class="recap-text">{{ Tva }} €</span>
                </div>
               
                <div class="my-3 my-md-4 row">
                  <p class="col-12 col-lg-10">
                    <label class="recap-text">Livraison</label>
                    <br />
                    <span class="text-slogan">Frais calculés à l'étape suivante</span>
                  </p>
                </div>
                <hr class="divider" />
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if='tvaTieCode==="0"'>
                  <label class="recap-text">Total TVA inclus</label>
                  <span class="recap-text-blue px-0">{{ TotalCartTTC }} € TTC</span>
                </div>
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-else>
                  <label class="recap-text">Total</label>
                  <span class="recap-text-blue px-0">{{ TotalCartTTC }} € HT</span>
                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <button
                      class="btn text-white btn-check-order mt-2 w-100 w-lg-60"
                      :disabled="!selectedLiv || isSubmitting"
                      @click="ConfirmCommande()"
                    >
                      <span
                        v-if="isSubmitting"
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span>{{ isSubmitting ? "Confirmation en cours..." : "Confirmer" }}</span>
                    </button>
                  </div>
                  <div class="col-12 text-center mt-2">
                    <span class="text-slogan mt-3">Paiement 100% sécurisé avec technologies ssl et 3D Secure.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import iconlocation from "@/assets/location.svg";
  import user from "@/assets/images/user.svg";
  import phone from "@/assets/images/phone.svg";
  import envelope from "@/assets/images/envelope.svg";
  import checked from "@/assets/images/check-box-orange.png";
  import { useCartStore } from "@/stores/cartStore";
  import { useRegisterStore } from "@/stores/register";
  import { useAddressesStore } from "@/stores/esupplyvet/addressesStore";
  import { updateOrder } from "@/api/orders";
  import { useCheckoutStore } from "@/stores/useCheckoutStore";
  import { useDelegueStore } from '@/stores/delegueStore';
  import { useShippingMethodesStore } from "@/stores/shippingMethodStore";
  import { updateShipmentShippingMethod, getOrderDetails } from "@/api/orders";

  export default {
    name: "LivraisonCliniquePage",
    data() {
      return {
        user,
        phone,
        envelope,
        checked,
        cart: {
          items: [],
        },
        cartStore: null,
        registerStore: null,
        addressesStore: null,
        shippingMethodStore: null,
        delegueStore: null,
        iconlocation,
        selectedLiv: null,
        isSubmitting: false,
      };
    },
    computed: {
      TotalCart() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsSubtotal / 100;
        return this.formatPrice(total);
      },
      Tva() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = (cartStore.Cart.taxTotal - (cartStore.Cart.shippingTotal - cartStore.Cart.shippingTaxTotal) )/ 100;
        return this.formatPrice(total);
      },

       remise() {
        var total = 0;
        var cartStore = useCartStore();
        total = cartStore.Cart.orderPromotionTotal / 100;
        return total ? this.formatPrice(total) : 0;
      },
      couponCode() {
        const cartStore = useCartStore();
        return cartStore.Cart?.coupon_code || "";
      },

      tvaTieCode() {
        var cartStore = useCartStore();
        return cartStore.Cart.tvaTieCode
      },
      TotalCartTTC() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsTotal / 100;
        return this.formatPrice(total);
      },
      cartsupp() {
        var cartStore = useCartStore();
        return cartStore.Cart;
      },
     ListAddressesFacturations() {
      var cartStore = useCartStore();
        if (this.isDelegue && cartStore.Cart?.vetCustomer?.adressesFacturation) {
          // Delegate user - use vet customer's billing address
          console.log('Using delegate vet billing address from cart');
          return cartStore.Cart.vetCustomer.adressesFacturation;
        } else {
          // Regular user or client - use register store data
          console.log('Using regular vet billing address from register store');
          return this.registerStore.Veterinaire?.adressesFacturation;
        }
      },
      ListAddressesLivraison() {
        const role = this.registerStore.user?.role;
        const isClient = role === "client";

        if (isClient) {
            return this.addressesStore.clinicAddresses.map(address => ({
            id: address.id || `clinic_${Math.random().toString(36).substr(2, 9)}`,
            firstName: address.firstName || '',
            lastName: address.lastName || '',
            street: address.street || address.complete || '',
            postcode: address.postcode || '',
            city: address.city || '',
            cellphone: address.cellphone || '',
            email: address.email || '',
            countryCode: address.countryCode || '',
            adrcod: address.adrcod || null,
          }));
        }
        return this.addressesStore.clinicAddresses;
      },
      loading() {
        return this.cartStore.loading;
      },

       isClient() {
        return this.registerStore.user?.role === "client";
      },

        isDelegue() {
        return this.registerStore.user?.role === "delegues";
      },

       showWarehouseNotice() {
        const today = new Date();
        const deadline = new Date('2026-01-07T00:00:00');
        return today < deadline;
      },
      showRemiseLine() {
        const subtotal = this.cartsupp?.itemsSubtotal || 0;
        const remiseValue = Math.abs(this.cartsupp?.orderPromotionTotal || 0);
        return subtotal > 0 && remiseValue > 0 && remiseValue < subtotal;
      },
      
    },
    created() {
      this.cartStore = useCartStore();
      this.registerStore = useRegisterStore();
      this.delegueStore = useDelegueStore();
      this.addressesStore = useAddressesStore();
      this.shippingMethodStore = useShippingMethodesStore();
      if (!this.shippingMethodStore.ShippingMethodes || this.shippingMethodStore.ShippingMethodes.length === 0) {
        this.shippingMethodStore.fetchShippingMethodes(this.registerStore.user?.role, this.delegueStore?.selectedVeterinarian?.id);
      }
      this.registerStore.fetchVeterinaire();
      this.addressesStore.fetchAddresses();
    },
    methods: {
      formatPrice(value) {
        if (value == null || isNaN(value)) return '0,00';
        const num = Number(value);
        return num.toFixed(2).replace('.', ',');
      },
      async ConfirmCommande() {
        if (this.isSubmitting) return;

        try {
          const order = this.cartsupp;
          const tokenValue = order?.tokenValue;

          if (!tokenValue) {
            console.error("Aucun tokenValue pour la commande");
            return;
          }

          // Adresse sélectionnée
          const selectedAddressId = this.selectedLiv;

          let shippingAddress = null;
          if (this.isClient && this.ListAddressesLivraison.length) {
            shippingAddress = this.ListAddressesLivraison.find(addr => addr.id === selectedAddressId);
          } else {
            shippingAddress =
              this.ListAddressesLivraison.find(addr => addr.id === selectedAddressId) || this.ListAddressesFacturations;
          }

          if (!shippingAddress) {
            console.error("Adresse de livraison introuvable");
            return;
          }

          this.isSubmitting = true;

          const shippingAddressPayload = {
            firstName: shippingAddress.firstName,
            lastName: shippingAddress.lastName,
            street: shippingAddress.street,
            postcode: shippingAddress.postcode,
            city: shippingAddress.city,
            cellphone: shippingAddress.cellphone,
            email: shippingAddress.email,
            countryCode: shippingAddress.countryCode,
            adrcod: shippingAddress.adrcod || null, 
          };

          const billingAddressPayload = this.ListAddressesFacturations
            ? {
                firstName: this.ListAddressesFacturations.firstName,
                lastName: this.ListAddressesFacturations.lastName,
                street: this.ListAddressesFacturations.street,
                postcode: this.ListAddressesFacturations.postcode,
                city: this.ListAddressesFacturations.city,
                cellphone: this.ListAddressesFacturations.cellphone,
                email: this.ListAddressesFacturations.email,
                countryCode: this.ListAddressesFacturations.countryCode,
                adrcod:  this.ListAddressesFacturations.adrcod || null,
              }
            : shippingAddressPayload;
          const couponCodePayload = order.coupon_code || "";
          const payload = {
            //email: this.registerStore.user?.email || "",//
            billingAddress: billingAddressPayload,
            shippingAddress: shippingAddressPayload,
          };

          if (couponCodePayload) {
            payload.couponCode = couponCodePayload;
          }
          const checkoutStore = useCheckoutStore();
          const delegueStore = useDelegueStore();
          const registerStore = useRegisterStore();
          const vetId = delegueStore.getSelectedVeterinarian?.id;
          const userRole = registerStore.user?.role || "";

          const response = await updateOrder(tokenValue, payload, userRole === "delegues", vetId);
          checkoutStore.setOrder(response.data);
          this.$router.push({ name: "mode-paiement" });
        } catch (error) {
          console.error("Erreur lors de la confirmation de la commande :", error);
        } finally {
          this.isSubmitting = false;
        }
      },
      GoToStepCart() {
        this.$router.push({ name: "my-cart" });
      },
      async GoToLivraisonDomicile() {
        try {
          const selectedMode = this.shippingMethodStore.ShippingMethodes.find(mode => mode.code === "OLD8ID");

          if (!selectedMode) {
             console.error("Mode de livraison domicile non trouvé.");
             this.$router.push({ name: "livraison-domicile" }); // Fallback navigation
             return;
          }

          const tokenValue = this.cartsupp.tokenValue;
          const order = await getOrderDetails(tokenValue);
          const shippingMethodIRI = `/api/v2/shop/shipping-methods/${selectedMode.code}`;
          const shipmentId = order.data.shipments?.[0]?.id;

          if (shipmentId) {
             await updateShipmentShippingMethod(tokenValue, shipmentId, shippingMethodIRI);
             const checkoutStore = useCheckoutStore();
             checkoutStore.setShippingMethod(selectedMode.code);
          }
        } catch (err) {
          console.error("Erreur lors de la mise à jour du mode de livraison:", err);
        }
        this.$router.push({ name: "livraison-domicile" });
      },
      BackToLivraison() {
        this.$router.push({ name: "livraison" });
      },

      GoToDashboard() {
        this.$router.push({ name: "dashboard-home" });
      },
    },
  };
</script>

<style scoped>
  .livraison-page {
    padding: 15px;
    text-align: center;
    background: #f5f6f9;
    min-height: 500px;
  }
  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    padding: 0 15px;
    .title-page {
      font-size: 30px;
      font-weight: bold;
      color: #1e347d;
    }
    label {
      font-size: 15px;
      font-weight: normal;
      span {
        color: #1e347d;
      }
    }
  }
  .step-cart {
    justify-content: center;
    margin-bottom: 3rem;
  }
  .title-blue {
    color: #1e347d;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .step-cart-centent {
    justify-content: center;
    border: 1px solid #aeb1ba;
    border-radius: 10px;
  }
  .badge-blue {
    background-color: #1e347d !important;
    color: white !important;
    border-radius: 50%;
    font-size: 1.5rem;
  }
  .badge {
    background-color: #eee;
    color: #ec621a;
    border-radius: 50%;
    font-size: 1.5rem;
  }
  .step-cart .step-title {
    color: #000;
    font-weight: bold;
    font-size: 18px;
    opacity: 0.7;
  }
  /************Addresse List*******************/
  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .radio-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 2px solid #aeb1ba;
    padding: 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: border-color 0.3s;
  }

  .radio-option:hover,
  .radio-option.selected {
    background: #f5f6f9 0% 0% no-repeat padding-box;
    border: 2px solid #1e347d;
  }

  .location {
    flex: 1;
  }
  .radio-adresse {
    text-align: justify;
    font-family: "DM Sans", sans-serif !important;
  }

  .line1 {
    display: flex;
    align-items: center;
    color: #363739;
    font-size: 15px;
    margin-bottom: 8px;
    gap: 8px;
    font-family: "DM Sans", sans-serif !important;
  }

  .line2 {
    display: flex;
    color: #363739;
    font-size: 15px;
    gap: 16px;
    font-family: "DM Sans", sans-serif !important;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
  }

  .custom-radio {
    position: relative;
    padding-left: 24px;
    display: flex;
    align-items: center;
  }

  /* Cache l'input natif */
  .custom-radio input[type="radio"] {
    opacity: 0;
    position: absolute;
    right: 0;
    height: 0;
    width: 0;
  }

  /************Fin Addresse List****************/
  .block-recap {
    background: white;
    text-align: left;
    padding: 30px;
    max-height: max-content;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.1);
    .title-recap {
      color: #1e347d;
      font-size: 20px;
      font-weight: bold;
    }
    .recap-text {
      font-size: 20px;
    }
    .recap-text-blue {
      font-size: 20px;
      color: #1e347d;
      font-weight: bold;
    }
    .text-slogan {
      font-size: 12px;
      color: #1e347d;
      font-style: italic;
    }
    .divider {
      width: 90%;
      position: relative;
      left: 5%;
    }
  }

  .error,
  .empty {
    color: #777;
    font-size: 1.2em;
  }

  .error {
    color: red;
    font-weight: bold;
  }

  .empty {
    color: #888;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 1.2rem;
  }

  .spinner {
    border: 4px solid;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  /* Responsive Styles pour mobiles uniquement */
  @media (max-width: 768px) {
    .livraison-page {
      padding: 10px;
    }

    .section-header-breadcrumb {
      padding: 0 10px;
      text-align: center;
    }

    .section-header-breadcrumb .title-page {
      font-size: 24px;
      text-align: center;
    }

    .section-header-breadcrumb .breadcrumb-text {
      font-size: 14px;
      text-align: center;
    }

    .content.cart-page-inner {
      gap: 20px !important;
    }

    .block-adresses {
      margin-bottom: 1rem;
    }

    .step-cart {
      margin-bottom: 1.5rem;
    }

    .title-blue {
      font-size: 16px;
    }

    .shipping-icon {
      width: 20px;
      height: 20px;
    }

    .radio-option {
      padding: 12px;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    .custom-radio {
      align-self: flex-end;
      padding-left: 0;
    }

    .line1 {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .line2 {
      flex-direction: column;
      gap: 8px;
    }

    .radio-adresse {
      font-size: 14px;
    }

    .block-recap {
      padding: 20px;
    }

    .block-recap .title-recap {
      font-size: 18px;
      text-align: center;
      display: block;
      width: 100%;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 16px;
    }

    .btn-check-order {
      width: 100%;
      padding: 12px;
    }

    .back-link {
      display: inline-block;
      margin-bottom: 0.5rem;
    }
  }

  @media (max-width: 576px) {
    .section-header-breadcrumb .title-page {
      font-size: 20px;
    }

    .breadcrumb-text {
      font-size: 13px !important;
    }

    .title-blue {
      font-size: 15px;
    }

    .radio-option {
      padding: 10px;
    }

    .block-recap {
      padding: 15px;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 15px;
    }

    .radio-adresse {
      font-size: 13px;
    }

    .line1,
    .line2 {
      font-size: 14px;
    }
  }

  /* Pour les très petits écrans */
  @media (max-width: 360px) {
    .section-header-breadcrumb .title-page {
      font-size: 18px;
    }

    .breadcrumb-text {
      font-size: 12px !important;
    }

    .radio-option {
      padding: 8px;
    }

    .block-recap {
      padding: 12px;
    }
  }
</style>